document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('.c-main-product__buy') || document.querySelector('.c-grouped-products');
  const secondTarget = document.querySelector('.product__media-wrapper');
  const fixedButton = document.querySelector('.c-main-product__buy-fixed');
  const mobileMQ = window.matchMedia('(max-width: 767px)');

  if (target && fixedButton) {
    let isTargetVisible = false;
    let isSecondVisible = false;

    const isMobile = () => mobileMQ.matches;

    const updateFixed = () => {
      if (isMobile() || (!isTargetVisible && !isSecondVisible)) {
        fixedButton.classList.add('animate-in');
      } else {
        fixedButton.classList.remove('animate-in');
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.target === target) isTargetVisible = e.isIntersecting;
          if (e.target === secondTarget) isSecondVisible = e.isIntersecting;
        });
        updateFixed();
      },
      { threshold: 0 },
    );

    observer.observe(target);
    if (secondTarget) observer.observe(secondTarget);
    mobileMQ.addEventListener('change', updateFixed);
    updateFixed();
  }

  const items = Array.from(document.querySelectorAll('.accordion-item'));

  if (!items.length) return;

  items.forEach((item) => {
    const body = item.querySelector('.accordion-body');
    body.style.height = '0px';
    body.style.opacity = '0';
  });

  items.forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const body = item.querySelector('.accordion-body');

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');

      items.forEach((i) => {
        i.classList.remove('open');
        const b = i.querySelector('.accordion-body');
        b.style.height = '0px';
        b.style.opacity = '0';
      });

      if (!isOpen) {
        item.classList.add('open');
        const scrollHeight = body.scrollHeight;
        body.style.height = scrollHeight + 'px';
        body.style.opacity = '1';
      }
    });
  });
});
